import { useQuery } from '@tanstack/react-query';
import { reconciliationApi } from '../services/api-client';
import type { ReconciliationAlertSummary } from '../types';

export const reconciliationKeys = {
  all: ['reconciliation'] as const,
  alerts: () => [...reconciliationKeys.all, 'alerts'] as const,
  findings: (kind?: string, limit?: number) =>
    [...reconciliationKeys.all, 'findings', { kind, limit }] as const,
  findingDetail: (id: string) => [...reconciliationKeys.all, 'detail', id] as const,
};

export function useReconciliationAlerts() {
  return useQuery<ReconciliationAlertSummary>({
    queryKey: reconciliationKeys.alerts(),
    queryFn: () => reconciliationApi.getAlerts(),
    refetchInterval: 30_000, // 30s background poll
    staleTime: 10_000,
  });
}
